export const AUTOMATION_SURVEY_PROMPT_CHECK_EVENT = "xpro:automation-survey-prompt-check";

/**
 * Solicita ao host global que busque pesquisas pendentes (ex.: após alterar status).
 * @param {number|string|null} leadId
 */
export function requestAutomationSurveyPromptCheck(leadId = null) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(AUTOMATION_SURVEY_PROMPT_CHECK_EVENT, {
      detail: {
        leadId: leadId != null && leadId !== "" ? Number(leadId) : null,
      },
    })
  );
}

export function readAutomationSurveyPromptCheckDetail(event) {
  const leadId = event?.detail?.leadId;
  if (leadId == null || leadId === "") return null;
  const n = Number(leadId);
  return Number.isFinite(n) && n > 0 ? n : null;
}
